import React from 'react';
import { themer } from '@spp/theme-provider';
import { SlideContext } from '@spp/ui-gallery';
import VideoAsset from '@spp/video-asset';
import { config } from '../../config';

/* eslint react/prop-types: 0 */
const GalleryVideo = ({ title = {}, videoAsset, ...rest }) => {
    const {
        video: { locale, vendor, shareLink, plugins, skin, playerUrl } = {},
        iris: { host } = {},
    } = config;
    const { value: videoTitle } = title;

    const getPlayerConfig = (videoConfig) => ({
        ...videoConfig,
        locale,
        vendor,
        title: videoTitle,
        sharing: { link: shareLink + videoAsset.id },
        plugins,
        skin,
    });

    return (
        <SlideContext>
            {({ isActive }) => (
                <VideoAsset
                    forcePause={!isActive}
                    getPlayerConfig={getPlayerConfig}
                    reduxPath="video"
                    videoAsset={videoAsset}
                    autoplayNext
                    apiUrl={host}
                    videoPlayerUrl={playerUrl}
                    {...rest}
                />
            )}
        </SlideContext>
    );
};

export default themer('@spp/ui-gallery:video')(GalleryVideo);



/** WEBPACK FOOTER **
 ** ./src/local-components/article/GalleryVideo.js
 **/